/**
 * Shared dynamic-variable allow-list for body-level custom fields that
 * integrations apply to their RMA-equivalent document (NetSuite RMA, Brightpearl
 * sales credit, etc.).
 *
 * Adding a new entry here lights up the option in every integration's settings
 * UI and forces the shared resolver to provide a typed value for it.
 * Integration-specific variables (e.g. NetSuite line-item variables, NetSuite
 * rate-amount template variables) stay in their integration's own model file.
 */
export const ALLOWED_DYNAMIC_VARIABLES_ON_RMA_BODY_LEVEL = [
  "trackingNumber",
  "carrierName",
  "compensationType",
  "exchangeAmount",
  "exchangeType",
  "storeCredit",
  "refundTotal",
  "upsellAmount",
  "orderId",
  "providerOrderName",
  "redoReturnId",
  "externalRmaNumber",
  "redoPortalUrl",
  "redoCreatedAt",
] as const;

export type AllowedDynamicVariableOnRmaBodyLevel =
  (typeof ALLOWED_DYNAMIC_VARIABLES_ON_RMA_BODY_LEVEL)[number];

export type RmaBodyLevelVariableMap = Record<
  AllowedDynamicVariableOnRmaBodyLevel,
  string
>;

/**
 * Classification of an exchange's cash/store-credit composition, used by the
 * `exchangeType` body-level variable. Originally a NetSuite-internal type;
 * promoted here so all RMA-equivalent integrations expose the same labels.
 */
export type RmaExchangeType =
  | "upsellExchange"
  | "evenExchange"
  | "downsellExchange"
  | "exchange+Refund"
  | "exchange+StoreCredit"
  | "exchange+Refund+StoreCredit";
